/*
 * Copyright (c) 2020. Sonrai Analytics Limited
 * Developed by Warren Dowey
 */
import { Directive, Output, EventEmitter, ElementRef, OnInit, Input } from '@angular/core';

@Directive({
  selector: 'img[loaded]',
})
export class ImageLoadedDirective implements OnInit {
  private hasLoaded = false;
  @Output() loaded = new EventEmitter<string>();
  @Input('key') key: string;

  constructor(private elRef: ElementRef<HTMLImageElement>) {}

  /**
   *  Warren Dowey
   *
   *  ngOnInit
   *
   *  this directive uses the image onload event, this was particulary tough as the host listener repeats on the same object
   * so had to default to vanilla
   */
  ngOnInit(): void {
    this.elRef.nativeElement.id = this.key;
    if (this.elRef.nativeElement.complete) {
      this.hasLoaded = true;
      this.loaded.emit(this.key);
    } else {
      this.elRef.nativeElement.onload = function (event) {
        event.preventDefault();
        if (this.hasLoaded) {
          this.elRef.nativeElement.onload = null;
          return;
        }
        this.hasLoaded = true;
        this.loaded.emit(this.key);
        this.elRef.nativeElement.onload = null;
      }.bind(this);
    }
  }
}
